<template>
  <el-config-provider :locale="$i18n.messages[$i18n.locale]">
    <div id="app">
      <router-view></router-view>
    </div>
  </el-config-provider>
</template>

<script>
import {
  useRouter
} from 'vue-router';

export default {
  name: 'App',
  components: {
  },
  setup() {
    const router = useRouter();
    router.beforeEach((to, from, next) => {
      console.log(to, from, next, '路由守卫');
      const role = sessionStorage.role;	//获取当前用户权限
      // console.log(to.meta.roles,role);

      if (to.matched.length === 0) {
        next('/404')
      } else if(to.meta.roles != undefined){
        if(to.meta.roles.includes('客户')) {  //页面需要用户权限
          if(role == undefined || role.length === 0) {
            next('/login');
          }
          else if (role.includes('管理员')) {
            next();
          }
          else if(role.includes('客服')) {
            next();
          }
          else if(role.includes('客户')) {
            next();
          }
          else
            next('/login');
        }
        else if(to.meta.roles.includes('管理员')) { // 页面需要管理员权限
          if(role == undefined || role.length === 0) {
            next('/login');
          }
          else if (role.includes('管理员')) {
            next();
          }
          else
            next('/login');
        }
        else if(to.meta.roles.includes('客服')) { // 页面需要客服权限
          if(role == undefined || role.length === 0) {
            next('/login');
          }
          else if (role.includes('客服')) {
            next();
          }
          else if (role.includes('管理员')) {
            next();
          }
          else
            next('/login');
        }
        else
          next('/login');
      }

      else
        next();
    })
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html {
  overflow: hidden;
}
*{
  margin: 0px;
  padding: 0px;
}
</style>
